import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';

import Activities from "../containers/Activities";
import ActivityRewrite from "../containers/ActivityRewrite";

function InboxRouter(props) {
	let {updateHeader, resetHeader, showSnackbar, setBannerClassName, hasNudgeBanner, updateUser} = props,
		routes = InboxRouter.getRoutes();

	return (
		<Switch>
			{/* /next/activities -> inbox */}
			<Redirect
				exact
				from={routes[0]}
				to={routes[1]} />

			{/* anonymous view */}
			<Redirect
				from={routes[2]}
				to={routes[3]} />
			<Route
				path={routes[4]}
				render={props =>
					<ActivityRewrite {...props}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar} />
				} />

			{/* with viewType in url for tracking */}
			<Route
				path={[routes[1], routes[5]]}
				render={renderProps =>
					<Activities
						{...renderProps}
						updateUser={updateUser}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar}
						hasNudgeBanner={hasNudgeBanner}
						setBannerClassName={setBannerClassName} />
				} />
		</Switch>
	);
}

InboxRouter.getRoutes = () => {
	const routes = [
		"/next/activities",
		"/inbox",
		"/v/:src/:user/:activity",
		"/inbox/rewrite/:src/:user/:activity",
		"/inbox/rewrite",
		"/inbox/:activityId/:viewType?"
	];
	return routes;
};

InboxRouter.propTypes = {
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
	hasNudgeBanner: PropTypes.bool,
	setBannerClassName: PropTypes.func,
	updateUser: PropTypes.func
};

export default InboxRouter;